import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { FAQS } from "@/data/site";
import { Plus } from "lucide-react";

export function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-24 sm:py-32" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <SectionHeading
          eyebrow="Domande Frequenti"
          title={
            <>
              Tutto chiaro, <span className="fire-text">prima di volare</span>
            </>
          }
          align="center"
        />

        <div className="mt-14 flex flex-col gap-4">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={f.q} delay={i * 0.05}>
                <div
                  className={`bg-[#13141B] border rounded-3xl overflow-hidden transition-colors duration-300 ${
                    isOpen ? "border-orange-500/50" : "border-white/10"
                  }`}
                  data-testid={`faq-accordion-item-${i}`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 text-left px-7 py-6"
                    data-testid={`faq-question-button-${i}`}
                  >
                    <span className="font-heading font-bold text-white text-base sm:text-lg">{f.q}</span>
                    <motion.span
                      animate={{ rotate: isOpen ? 45 : 0 }}
                      transition={{ duration: 0.3 }}
                      className={`shrink-0 ${isOpen ? "text-orange-500" : "text-slate-500"}`}
                    >
                      <Plus size={20} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                      >
                        <p className="px-7 pb-7 text-sm sm:text-base text-slate-400 leading-relaxed" data-testid={`faq-answer-${i}`}>
                          {f.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
